import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppMaterialModule } from '@app/app-material.module';
import { ComponentsModule } from '@shared/components/components.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { FaturamentoComponent } from '@modules/faturamento/pages/faturamento/faturamento.component';
import { FaturamentoController } from '@modules/faturamento/controllers';
import { DetalhesFaturamentoComponent } from '@modules/faturamento/components/detalhes-faturamento/detalhes-faturamento.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [FaturamentoComponent, DetalhesFaturamentoComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), FaturamentoController],
})
export class FaturamentoModule {}
